var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMusicTvShows = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Microphone-Stage--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Microphone Stage Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 20.41 21.39 1.35A1.51 1.51 0 0 0 20.24 0a1.49 1.49 0 0 0 -1.61 0.65l-3.52 5.59a0.26 0.26 0 0 0 0 0.3A4.48 4.48 0 0 1 16 7.9a0.23 0.23 0 0 0 0.2 0.15 0.25 0.25 0 0 0 0.24 -0.11l2.75 -4.33a0.24 0.24 0 0 1 0.27 -0.11 0.25 0.25 0 0 1 0.19 0.22l1.62 16.67a0.23 0.23 0 0 1 -0.06 0.2c-0.48 0.49 -2.62 1.41 -6.42 1.41 -3.39 0 -5.47 -0.73 -6.21 -1.22a0.25 0.25 0 0 1 -0.07 -0.34l3.85 -6.07a0.27 0.27 0 0 0 0 -0.26 0.26 0.26 0 0 0 -0.24 -0.13l-0.34 0a4.23 4.23 0 0 1 -1.24 -0.18 0.26 0.26 0 0 0 -0.28 0.11L6.41 20a1 1 0 0 0 -0.16 0.54c0 2.41 4.41 3.5 8.5 3.5s8.5 -1.09 8.5 -3.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 18.25a0.25 0.25 0 0 1 -0.25 0.25h-0.5a1 1 0 0 0 0 2h3a1 1 0 0 0 0 -2 0.25 0.25 0 0 1 -0.25 -0.25v-2.1a0.22 0.22 0 0 1 0.12 -0.21 0.23 0.23 0 0 1 0.24 0 1.42 1.42 0 0 0 1.58 -2.3l-2.32 -2.34 -1.09 -1.09a0.26 0.26 0 0 1 -0.07 -0.22 2.63 2.63 0 0 0 0 -0.49 3 3 0 1 0 -3 3 3.13 3.13 0 0 0 1 -0.16 0.23 0.23 0 0 1 0.25 0.06l1.21 1.21a0.22 0.22 0 0 1 0.07 0.17Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11a0.49 0.49 0 0 0 0.49 -0.43l0.06 -0.4a2.51 2.51 0 0 1 2.12 -2.12l0.4 -0.05a0.51 0.51 0 0 0 0 -1l-0.4 0a2.51 2.51 0 0 1 -2.12 -2.17l-0.06 -0.4a0.49 0.49 0 0 0 -1 0l-0.06 0.4A2.51 2.51 0 0 1 1.33 7l-0.4 0a0.51 0.51 0 0 0 0 1l0.4 0.05a2.51 2.51 0 0 1 2.12 2.12l0.06 0.4A0.49 0.49 0 0 0 4 11Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.18 3 0.26 0a1.52 1.52 0 0 1 1.28 1.3l0 0.27a0.51 0.51 0 0 0 1 0l0 -0.27A1.52 1.52 0 0 1 13.06 3l0.26 0a0.49 0.49 0 0 0 0.43 -0.49 0.51 0.51 0 0 0 -0.43 -0.5l-0.26 0A1.51 1.51 0 0 1 11.78 0.69l0 -0.26a0.51 0.51 0 0 0 -1 0l0 0.26A1.51 1.51 0 0 1 9.44 2l-0.26 0a0.51 0.51 0 0 0 -0.43 0.5 0.49 0.49 0 0 0 0.43 0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMusicTvShows);
export default ForwardRef;